import { ModelSagres } from "../../model-sagres";
import { Contrato } from "./contrato";

export class ArquivoContrato extends ModelSagres {
  IdArquivo: number;
  IdContrato: number;
  DePathArquivo: string;
  DeNomeArquivo: string;
  IsArquivoEdital: boolean;
  NmUsuarioResponsavel: string;
  DtInsercao: Date;

  IdContratoNavigation: Contrato;
}
